<script lang="ts">
	import Counter from '../counter/Counter.svelte'
	import FilterIcon from './FilterIcon.svelte'
	import { _ } from '@repo/i18n'
	import { Action, ButtonType, FormValidator } from '@repo/ui'
	import { Button } from '@repo/ui'
	import { Dropdown } from '@repo/ui'
	import { DropdownHeader } from '@repo/ui'
	import { DropdownSeparator } from '@repo/ui'
	import { Icon } from '@repo/ui'
	import { DisableHubspot } from '@repo/ui'
	import { Check, ChevronDown } from '@steeze-ui/heroicons'
	import { createEventDispatcher } from 'svelte'

	interface Props {
		activeFiltersCount: number
		groupedRight?: boolean
		groupedLeft?: boolean
		isFilterOpen?: boolean
		children?: import('svelte').Snippet
	}

	let {
		activeFiltersCount,
		groupedRight = false,
		groupedLeft = false,
		isFilterOpen = $bindable(false),
		children,
	}: Props = $props()

	const dispatch = createEventDispatcher()
</script>

<div class={isFilterOpen ? 'relative z-30' : ''}>
	<Dropdown bind:opened={isFilterOpen}>
		{#snippet placeholder({ onclick })}
			<button
				class="
      flex items-center space-x-2 border px-6 py-2 text-right text-base text-gray-900 hover:bg-gray-100
      dark:text-gray-200 dark:hover:bg-gray-800
      {groupedRight ? '' : 'rounded-r-lg'}
      {groupedLeft ? '' : 'rounded-l-lg'}
      {activeFiltersCount > 0 ? 'bg-primary-50 dark:bg-primary-900' : 'bg-white dark:bg-gray-900'}
      {isFilterOpen || activeFiltersCount > 0
					? 'border-primary-500'
					: 'border-gray-200 dark:border-gray-500'}
    "
				data-test="button-filter"
				{onclick}
			>
				<span class:text-primary-500={isFilterOpen || activeFiltersCount > 0}>
					<FilterIcon />
				</span>
				<span>
					{$_('button.filter')}
				</span>
				{#if activeFiltersCount > 0}
					<Counter>
						{activeFiltersCount}
					</Counter>
				{/if}
				<span class="flex text-gray-400 {isFilterOpen ? 'rotate-180' : ''}">
					<Icon class="dark:text-white" src={ChevronDown} />
				</span>
			</button>
		{/snippet}

		<div
			class="border-primary-500 absolute top-full mt-2 w-[calc(100vw_-_24px)] rounded-lg border
      bg-white p-6 shadow-md max-sm:left-0 sm:right-0 sm:max-w-[32rem] lg:max-w-2xl
      dark:bg-gray-800"
		>
			<FormValidator name="filter-form" onsubmit={() => dispatch('save')}>
				<DropdownHeader title={$_('filters.title')}>
					<div class="flex items-center space-x-4">
						<div>
							<Action name="clear-filter" onclick={() => dispatch('clear')}>
								<div class="text-red-500 dark:text-red-300">
									{$_('filters.clear')}
								</div>
							</Action>
						</div>
						<Button
							name="filter-save"
							icon={Check}
							label={$_('button.save')}
							type={ButtonType.submit}
						/>
					</div>
				</DropdownHeader>

				<DropdownSeparator />
				{@render children?.()}

				<DisableHubspot />
			</FormValidator>
		</div>
	</Dropdown>
</div>
